import(/* webpackMode: "eager" */ "/app/src/app/(main)/(protected)/account/page.tsx");
